import React, { PropTypes } from "react";
import { change as changeFieldValue, Field, reduxForm, getFormValues} from "redux-form";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { SelectInput } from "../../common/form";
import _ from "lodash";
import * as dataActions from "../../../utils/data/dataActions";

class SynchronizationDataFilters extends React.Component {
  componentDidMount() {
    this.updateSelectedUserId(String(this.props.auth.user.userId));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dirty && !_.isEqual(nextProps.values, this.props.values)) {
      nextProps.onFilterChange(nextProps.values);
    }
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.isModificationOnly !== this.props.isModificationOnly) {
      this.updateSelectedUserId(String(this.props.auth.user.userId));
    }
  }
  
  updateSelectedUserId(currentUserId) {
    if (this.props.isModificationOnly) {
      this.props.changeFieldValue("synchronizationDataFilters", "userId", currentUserId);
    } else {
      this.props.changeFieldValue("synchronizationDataFilters", "userId", null);
    }
  }

  render() {
    return (
    <div className="list-filters-container">
      <Field
        id="userId"
        name="userId"
        component={SelectInput}
        addBlankOption={true}
        blankMessageKey="synchronizations.datatable.filters.allUsers"
        options={this.props.userOptions}
        label={<FormattedMessage id="synchronizations.datatable.columns.user" />}
        searchable={true}
        disabled={this.props.isModificationOnly}
      />

      <Field
        id="clientId"
        name="clientId"
        component={SelectInput}
        addBlankOption={true}
        blankMessageKey="synchronizations.datatable.filters.allClients"
        options={this.props.clientOptions}
        label={<FormattedMessage id="synchronizations.datatable.columns.client" />}
        searchable={true}
      />

      <Field
        id="elementType"
        name="elementType"
        component={SelectInput}
        addBlankOption={true}
        blankMessageKey="synchronizations.datatable.filters.allElementTypes"
        options={this.props.elementTypeOptions}
        label={<FormattedMessage id="synchronizations.datatable.columns.elementType" />}
        searchable={true}
      />
    </div>
    );
  }
}

SynchronizationDataFilters.propTypes = {
  auth: PropTypes.object,
  dirty: PropTypes.bool,
  onFilterChange: PropTypes.func.isRequired,
  values: PropTypes.object,
  userOptions: PropTypes.array,
  clientOptions: PropTypes.array,
  elementTypeOptions: PropTypes.array,
  isModificationOnly: PropTypes.bool,
	changeFieldValue: PropTypes.func,
};


const valueSelector = getFormValues("synchronizationDataFilters");
function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    values: valueSelector(state),
    auth: state.auth
  };
}

SynchronizationDataFilters = connect(mapStateToProps, mapDispatchToProps)(SynchronizationDataFilters);

export default reduxForm({
  form: "synchronizationDataFilters",
})(SynchronizationDataFilters);


// WEBPACK FOOTER //
// ./src/components/dashboard/synchronization/SynchronizationDataFilters.js